import React, {Component} from 'react';
import {connect} from "react-redux";
import * as actionCreator from "../../../../store/Action";
import '../CreateLocation/style.css'
import Download from '../../../../components/Button/DownloadbleButton'

import { Card, CardBody, CardHeader} from 'reactstrap';
import {MDBDataTable} from 'mdbreact'
import {Button as SementicBtn} from 'semantic-ui-react'
import {Icon, Spin} from "antd";
import FloorUpdate from "./FloorUpdate/FloorUpdate";
import BuildingUpdate from "./BuildingUpdate/BuildingUpdate";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import * as common from "../../../../const/Common/CommonFunc";
import MapView from "../../Branches/MapView/MapView";
import {geocodeByAddress, getLatLng} from "react-places-autocomplete";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import apiConfig from "../../../../axios/axios_api_services";

class App extends Component {

  state = {
    floor_modal: false,
    building_modal: false,
    floors_list: [],
    building_id: 0,
    building_obj: null,
    isSpin: false,
    building_list: [],
    isMap:false,
    location_:'',
    latLng: null,
    selectedBuilding:0,
  };

  modalHandler = (state_name, condition) => {
    this.setState({
      [state_name]: condition
    })
  };

  viewFloor = (list,buildingId) => {
    this.setState({
      floors_list: list,
      selectedBuilding: buildingId
    });

    this.modalHandler("floor_modal", true);
  };
  getAllLocations = () => {

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        let building_list = [];
        if (response.data.success) {

          let branchList = response.data.branchList;
          if (branchList.length !== 0) {
            branchList.map((branch, index) => {
              if (branch.buildings.length !== 0) {
                branch.buildings.map((building, buildIndex) => {

                  const obj = {
                    branchId: branch.branchId,
                    buildingId: building.buildingId,
                    code: building.code,
                    floors: building.floors,
                    levelCount: building.levelCount,
                    location: building.location,
                    name: building.name,
                    status: building.status,
                  };
                  building_list.push(obj)
                })
              }
            })
          }
          this.setState({
            building_list: building_list
          })
        } else {
          this.setState({
            building_list: []
          })
        }

        //  dashboard single type
        this.props.addTagsDashboardSingle("buildingsCount",building_list.length !== 0 ? 1 : 0);
        //  --------
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllLocations()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
      });

  };
  updateLocation = (obj) => {
    this.setState({
      building_obj: obj,
      building_modal: true
    })
  };
  deleteLocation_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.delete(apiConfig.CORPORATE_BRANCH_BUILDING_DELETE(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Floor details successfully deleted", 0);
          this.getAllLocations();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteLocation_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  deleteLocation = (buildingId,name) => {
    swal({
      title:"Do you want to delete this building? First please enter \""+name+"\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if(value === name){
          this.deleteLocation_(buildingId)
        }else{
          common.warningAlert("Can't delete building", 1)
        }
      });

  };
  tableButtonClick = (e, type, index,buildingId) => {

    switch (type) {
      case 'updateLocation':
        this.updateLocation(index);
        break;
      case 'deleteLocation':
        this.deleteLocation(index,buildingId); // buildingId,buildingName
        break;
      case 'viewFloor':
        this.viewFloor(index,buildingId);
        break;
      case 'updateFloor':
        this.updateFloor(index);
        break;
      case 'deleteFloor':
        this.deleteFloor(index);
        break;

      case 'viewLocation':
        geocodeByAddress(index)
          .then(results => getLatLng(results[0]))
          .then(latLng => this.setState(
            {latLng: latLng, isMap: true, location_: index}
          ))
          .catch(error => common.notifyMessage(error));
        break;

      default:
        break;
    }

  };

  changeSpinner = (condition) => {
    this.setState({
      isSpin: condition
    })
  };

  componentDidMount() {
    this.getAllLocations();
  };

  viewMap = () => {
    this.setState({
      isMap: !this.state.isMap,
    })
  };

  render() {

    const rows = [];
    if(this.state.building_list.length !== 0){
      this.state.building_list.map((row, index) => {
        rows.push(
          {
            building: row.name,
            location: row.location,
            view:<SementicBtn icon='map marker alternate' circular color='teal'
                              onClick={e => this.tableButtonClick(e, 'viewLocation', row.location)}/>,
            code: row.code,
            level: row.levelCount,
            status: row.status,
            floor:
              <SementicBtn icon='eye' circular color={"linkedin"}
                           onClick={e => this.tableButtonClick(e, 'viewFloor', row.floors,row.buildingId)}/>,

            action:
              <div>
                <SementicBtn circular icon='edit' onClick={e => this.tableButtonClick(e, 'updateLocation', row)}/>
                <SementicBtn className="cus-btn" circular icon='trash alternate'
                             onClick={e => this.tableButtonClick(e, 'deleteLocation', row.buildingId,row.name)}/>
              </div>
          }
        )
      });
    }

    let columns = this.props.viewAllTable_data.columns;
    let table_data = {columns, rows};

    return (
      <div>
        <Card>
          {
            this.state.isMap ?
              <MapView location={this.state.location_} latLng={this.state.latLng} closeModal={this.viewMap}/> : null
          }
          {
            this.state.floor_modal ?
              <FloorUpdate buildingId={this.state.selectedBuilding} closeModal={this.modalHandler} floors_list={this.state.floors_list} refreshData={this.getAllLocations}/> : null
          }
          {
            this.state.building_modal ?
              <BuildingUpdate data={this.state.building_obj}  closeModal={this.modalHandler} refreshData={this.getAllLocations}/> : null
          }

          <CardHeader>
            View All Buildings
            <Download data={this.state.building_list} filename={"view-all-buildings.csv"}/>
          </CardHeader>
          <CardBody>
            <Spin spinning={this.state.isSpin} delay={10}
                  indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
              <MDBDataTable
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                data={table_data}/>
            </Spin>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  viewAllTable_data: state.COPLocationReducer.viewAllTable_data,
  floorViewTable_data: state.COPLocationReducer.floorViewTable_data,
  floors: state.COPLocationReducer.floors,
  locations: state.COPLocationReducer.locations,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getFloor: (data) => dispatch(actionCreator.getFloor(data)),
    getAllLocations: (data) => dispatch(actionCreator.getAllLocations(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // dashboard single value handler
    addTagsDashboardSingle: (type,data) => dispatch(actionCreator.addTagsDashboardSingle(type,data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
